var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Implementierungsdaten exportieren","action":"export","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('p',[_vm._v("In diesem Export erscheinen alle Daten, die zur Implementierung notwendig sind (Einbindungscode, Landingpage-URL, Cover-URL).")])])
}
var staticRenderFns = []

export { render, staticRenderFns }